import './Loader.css'
function Loader() {
  return (
    <div className='Loader'>
        <div className="lds-ring"><div /><div /><div /><div /></div>
    </div>
  )
}

export default Loader